<app-generic-label
  class="label theme-light"
  [label]="option.label"
  [fit]="mode === 'summary' ? 'fixed' : 'auto'"
  [opaque]="true"
  [pinDraggable]="mode === 'edit'"
  [tagDraggable]="mode === 'edit'"
  [isCollapsed]="collapsed"
  [descriptionCollapsed]="false"
  [hasContent]="true"
  [sequence]="sequence"
  (labelUpdated)="handleLabelUpdated($event)"
  (offsetUpdated)="handleOffsetUpdated($event)">
  <div class="label__body" label-body>
    <!-- edit form view -->
    <app-quiz-label-anatomy-select
      [outline]="false"
      [hidden]="mode === 'summary'"
      [options]="options"
      [formControl]="control">
    </app-quiz-label-anatomy-select>

    <!-- summary view -->
    <div *ngIf="mode === 'summary'" class="label__summary flex items-start" [ngSwitch]="correct">
      <app-icon
        class="label__icon label__icon--correct"
        style="font-size: 16px"
        icon="check-circle"
        *ngSwitchCase="true"></app-icon>
      <app-icon
        class="label__icon label__icon--incorrect"
        style="font-size: 16px"
        icon="times-circle"
        *ngSwitchCase="false"></app-icon>

      <div class="label__text pl-2" *ngSwitchCase="true">
        <em class="text-semibold">{{ option.label.title }}</em
        >.
      </div>

      <div class="label__text pl-2" *ngSwitchCase="false">
        <p class="pb-2">
          You selected
          <em class="text-semibold">{{ getSelectedLabel(options, control.value)?.title.trim() }}</em
          >.
        </p>

        <p>
          This is the <em class="text-semibold">{{ option.label.title.trim() }}</em
          >.
        </p>
      </div>
    </div>
  </div>
</app-generic-label>
